import './assets/main.css'
import { startDebuggerBlocker } from './utils/debugger-blocker.ts'


import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupFormkit } from './plugins/formkit'
import { setupI18n } from './plugins/i18n'
import { initFaro } from './observability/faro'

import App from './App.vue'
import { router } from './router'
import MIcon from './components/MIcon.vue'


const hostname = window.location.hostname.split('.')[0] ?? ''
if(hostname !== 'localhost' && hostname !== 'demo') {
  startDebuggerBlocker()
}

// RUM init — env'de VITE_FARO_URL set edilince devreye girer.
initFaro({
  tenant: import.meta.env.VITE_DEFAULT_TENANT_CODE ?? hostname,
  appName: 'yarisma-online2-app',
  appVersion: __APP_VERSION__ ?? '0.0.0',
  environment: import.meta.env.MODE,
})

const app = createApp(App)
app.use(createPinia())
app.use(router)
setupFormkit(app)
setupI18n(app)
app.component('MIcon', MIcon)

app.mount('#app')
